import { jsxs, jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { ModalWrapper, ModalBody, ModalFooter, ModalSecondaryButton, ModalPrimaryButton } from '@zooplus/ui-components';
import { useTranslation } from '../../../../hooks/useTranslations.js';
import { useOverlays } from '../../../../providers/OverlaysProvider.js';
import styles from './BaseModal.module.scss.js';

/**
 * Wraps the given children in a modal.
 */
const BaseModal = ({ modalId, heading, headingId, size, handleSubmit, onClose, dataZta, dataZtaPrimaryBtn, closeBtnAriaLabel, primaryButtonLabel, isLoading = false, disabledPrimaryBtn = false, disabledSecondaryBtn = false, isCloseOnBackdropClick = false, children, }) => {
    const { t } = useTranslation();
    const { checkIsActive, hideOverlay } = useOverlays();
    const closeModal = useCallback(() => {
        hideOverlay(modalId);
    }, [hideOverlay, modalId]);
    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        handleSubmit?.();
    };
    const isActive = checkIsActive(modalId);
    return isActive ? (jsxs(ModalWrapper, { size: size, isOpen: isActive, onClose: onClose ?? closeModal, heading: heading, headingId: headingId, closeBtnAriaLabel: closeBtnAriaLabel, "data-zta": dataZta, "data-testId": dataZta, closeOnBackdropClick: isCloseOnBackdropClick, children: [jsx(ModalBody, { "data-zta": `${dataZta}-body`, "data-testid": `${dataZta}-body`, children: isActive && children }), jsxs(ModalFooter, { children: [jsx(ModalSecondaryButton, { className: styles.modalCancel, onClick: onClose ?? closeModal, disabled: disabledSecondaryBtn, "data-zta": "closeModalBtnBottom", "data-testid": "closeModalBtnBottom", children: t('general.button.back') }), !!primaryButtonLabel && (jsx(ModalPrimaryButton, { onClick: handleClick, disabled: disabledPrimaryBtn, isLoading: isLoading, loadingIconType: "paw", "data-zta": dataZtaPrimaryBtn ?? 'confirmModalBtnBottom', "data-testId": dataZtaPrimaryBtn ?? 'confirmModalBtnBottom', children: primaryButtonLabel }))] })] })) : null;
};

export { BaseModal as default };
//# sourceMappingURL=BaseModal.js.map
